"use strict";
import { useEffect, useState } from "react";
import { AdaptiveWebModal, WebModalWithBottomAttachment } from "ui/src/components/modal/AdaptiveWebModal";
import { INTERFACE_NAV_HEIGHT } from "ui/src/theme";
import Trace from "features/telemetry/Trace";
import { isExtension, isInterface } from "utilities/src/platform";
import { enableScroll, disableScroll } from "ui/src/utils/ToggleScroll";
const ANIMATION_MS = 200;
export function Modal({
  children,
  name,
  onClose,
  fullScreen,
  backgroundColor,
  isModalOpen = true,
  alignment = "center",
  maxWidth,
  maxHeight,
  height,
  padding,
  bottomAttachment,
  gap,
  paddingX,
  paddingY,
  analyticsProperties,
  skipLogImpression,
  position,
  flex,
  zIndex,
  isDismissible = true
}) {
  const [fullyClosed, setFullyClosed] = useState(false);
  if (fullyClosed && isModalOpen) {
    setFullyClosed(false);
  }
  useEffect(() => {
    if (isModalOpen) {
      disableScroll();
    } else {
      enableScroll();
    }
    return () => {
      enableScroll();
    };
  }, [isModalOpen]);
  useEffect(() => {
    if (!isModalOpen) {
      const tm = setTimeout(() => {
        setFullyClosed(true);
      }, ANIMATION_MS);
      return () => {
        clearTimeout(tm);
      };
    }
    return void 0;
  }, [isModalOpen]);
  const ModalComponent = bottomAttachment ? WebModalWithBottomAttachment : AdaptiveWebModal;
  return <Trace logImpression={skipLogImpression ? false : isModalOpen} modal={name} properties={analyticsProperties}>
      {(isModalOpen || !fullyClosed) && <ModalComponent
    position={position}
    bottomAttachment={bottomAttachment}
    shadowOpacity={isExtension ? 0 : void 0}
    borderWidth={isExtension ? 0 : void 0}
    adaptToSheet={isInterface}
    alignment={alignment}
    backgroundColor={backgroundColor}
    height={height ?? (fullScreen ? "100%" : void 0)}
    isOpen={isModalOpen}
    m="$none"
    maxWidth={maxWidth}
    maxHeight={maxHeight}
    gap={gap}
    zIndex={zIndex}
    $sm={{
      p: padding ?? "$spacing12",
      ...isInterface && {
        "$platform-web": {
          height: height ?? "max-content",
          maxHeight: `calc(100dvh - ${INTERFACE_NAV_HEIGHT}px)`
        }
      }
    }}
    p={padding ?? "$spacing24"}
    px={paddingX}
    py={paddingY}
    flex={flex}
    onClose={isDismissible ? onClose : void 0}
  >
          {
    /*
      To keep this consistent with how the `Modal` works on native mobile, we only mount the children when the modal is open.
      It is critical for the modal to work this way or else it breaks existing assumptions throughout our codebase about when components are mounted / unmounted.
    */
  }
          {fullyClosed ? null : children}
        </ModalComponent>}
    </Trace>;
}
